import { render, staticRenderFns } from "./directory.vue?vue&type=template&id=2b708a8a&"
import script from "./directory.ts?vue&type=script&lang=js&"
export * from "./directory.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports